import { Select } from "antd";

const Option = Select.Option;

const TagsSelect = ({ setVariables, variables }) => {
  const onChange = (tags) => {
    setVariables({ ...variables, tags: tags.length > 0 ? tags : null });
  };

  return (
    <Select
      showSearch
      showAction={["focus", "click"]}
      placeholder="All Tags"
      value={variables.tags || []}
      mode="multiple"
      style={{ width: "100%" }}
      onChange={onChange}
      data-cy="tagsSelect"
    >
      <Option data-cy="Hospitalization" value="Hospitalization">
        Hospitalization
      </Option>
      <Option data-cy="Change In Condition" value="Change In Condition">
        Change In Condition
      </Option>
      <Option data-cy="Escalation" value="Escalation">
        Escalation
      </Option>
      <Option data-cy="New Enrollment" value="New Enrollment">
        New Enrollment
      </Option>
    </Select>
  );
};

export default TagsSelect;
